import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import LoanApplicationPDF from "./LoanApplicationPDF";
import { useSelector } from "react-redux";
import { selectFiles, selectFormData } from "../../ReduxStore/UserSlice";

const PreviewApplication = ({ open, onClose, handleSubmit, data: externalData, readOnly = false }) => {
  const pdfRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const data = useSelector(selectFormData);
  const loanDoc = useSelector(selectFiles);
  const userInfo = useSelector((state) => state?.user?.user);
  const effectiveData = externalData ? externalData : data;
  const combinedData = { ...effectiveData, loanDoc: externalData?.loanDoc ?? loanDoc ?? {}, userInfo, isPreSubmitPreview: !externalData, };

  const handleDownload = () => {
    if (pdfRef.current) {
      pdfRef.current.downloadPDF();
    }
  };

  const handleSubmitClick = async (e) => {
    setIsSubmitting(true);
    try {
      await handleSubmit(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "16px", overflow: "hidden" },
      }}
    >
      {/* Header with title + download */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pr: 2,
        }}
      >
        <Typography variant="h6">Application Preview</Typography>
        <Box>
          <IconButton onClick={handleDownload} color="primary">
            <DownloadIcon />
          </IconButton>
          <IconButton onClick={onClose} color="error">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* PDF Preview (render LoanApplicationPDF content) */}
      <DialogContent dividers sx={{ height: "80vh", overflowY: "auto" }}>
        <LoanApplicationPDF ref={pdfRef} data={combinedData} />
      </DialogContent>

      {/* Actions */}
      {!readOnly && (
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleSubmitClick}
            variant="contained"
            color="primary"
            disableElevation
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {isSubmitting ? "Submitting..." : "Submit Application"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default PreviewApplication;
